import { render, staticRenderFns } from "./SaveSuccessModal.vue?vue&type=template&id=506392e8&scoped=true"
import script from "./SaveSuccessModal.vue?vue&type=script&lang=js"
export * from "./SaveSuccessModal.vue?vue&type=script&lang=js"
import style0 from "./SaveSuccessModal.vue?vue&type=style&index=0&id=506392e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "506392e8",
  null
  
)

export default component.exports